/**
 * ADOBE CONFIDENTIAL
 * __________________
 * Copyright 2023 Adobe
 * All Rights Reserved.
 * __________________
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

export function setUrlParams(
  params: Record<string, string | number | null>
): void {
  const urlSearchParams = new URLSearchParams(window.location.search);

  Object.entries(params).forEach(([key, value]) => {
    if (value === null) {
      urlSearchParams.delete(key);
    } else {
      urlSearchParams.set(key, String(value));
    }
  });

  let url = window.location.pathname;
  url += `?${urlSearchParams.toString()}`;
  url += window.location.hash;

  window.history.replaceState({}, '', url);
}

export function getUrlParams(): Record<string, string> {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const params: Record<string, string> = {};

  urlSearchParams.forEach((value, key) => {
    params[key] = value;
  });

  return params;
}

export function getValidatedQuantityFromUrl(
  defaultQuantity: number = 1
): number {
  const urlParams = getUrlParams() || {};
  const quantityParam = urlParams.quantity; // 'quantity' is the key

  if (quantityParam) {
    const parsedQuantity = parseInt(quantityParam, 10);

    if (
      !isNaN(parsedQuantity) &&
      Number.isInteger(parsedQuantity) &&
      parsedQuantity > 0
    ) {
      // Return the valid quantity from the URL
      return parsedQuantity;
    }
  }

  // Return the default quantity if the parameter is missing, invalid, or not positive
  return defaultQuantity;
}
